import { Link } from "react-router-dom";
import { CATEGORIES, catalog } from "@/lib/catalog";

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 mt-10 md:mt-14">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {CATEGORIES.map((cat) => {
          const count = catalog.filter((m) => m.type === cat.key).length;
          return (
            <Link
              key={cat.key}
              to={`/category/${cat.key}`}
              className="group relative rounded-lg overflow-hidden bg-background-100 border border-background-300/50 p-5 md:p-6 hover:border-primary-500/60 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${cat.icon} text-3xl`} />
                </span>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {cat.label}
                    </h3>
                    <span className="text-[10px] tracking-widest text-secondary-500 font-label uppercase">
                      {cat.english}
                    </span>
                  </div>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                  <p className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-stack-line text-primary-500" />
                    共 {count} 部精选内容
                  </p>
                </div>
              </div>
              <i className="absolute bottom-4 right-5 ri-arrow-right-line text-xl text-foreground-500 group-hover:text-primary-500 group-hover:translate-x-1 transition-all" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}